/**
 * Summary: Opens link in new tab
 * @author:Mudassar Ali
 */
function openLinkInNewTab(e,url){
    if (e.stopPropagation)
        e.stopPropagation();
    var win = window.open(url, '_blank');
    win.focus();
}
var $selectElement = '';
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};

function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4()
    + s4() + s4();
}

function asArray(data) {
    if (Object.prototype.toString.call(data) === '[object Object]'
        || Object.prototype.toString.call(data) === '[object String]') {
        data = new Array(data);

    } else if (data === undefined) {
        data = new Array();
    }

    return data;
}

function SortByName(x, y) {
    return ((x.name == y.name) ? 0 : ((x.name < y.name) ? 1 : -1));
}

function objToString(obj) {
    var str = '';
    for ( var p in obj) {
        if (obj.hasOwnProperty(p)) {
            str += p + '::' + obj[p] + '\n';
        }
    }
    return str;
}

function oldDropdownValue($select) {
    var history = $select.data('history');
    $select.empty();
    history[0].options.forEach(function(value, index) {
        var option = $("<option></option>").attr("value", value.value).text(value.label);
        if (history[0].selectedVal == value.value) {
            $(option).attr('selected', true);
        }
        $select.append(option);
    });
    $select.data('history', history.splice(0));
    dodropdown($select.parent());
}

function saveDropdownValueHistory($select) {
    var selectedVal = $select.val();
    var values = [];
    $select.find('option').each(function(index, value) {
        values.push( {label:$(value).text(), value: $(value).val() });
    });
    var data = {selectedVal: selectedVal, options: values};
    var history = $select.data('history');

    if (!history) history = [];
    history.push(data);
    $select.data('history', history);
}

function dodropdown(scope, selector) {
    if (isBlank(scope)) {
        scope = 'body';
    }
    if (isBlank(selector)) {
        selector = '.dd-select';
    }
    // Iterate over each select element
    $(scope).find(selector).each(
            function() {
                // Cache the number of options
                var $this = $(this), numberOfOptions = $(this).children('option').length;
                
                //$this.data('history', []);
                saveDropdownValueHistory($this);
                // Insert a styled div to sit over the top of the hidden select
                // element
                // Cache the styled div
                var $styledSelect = $this.siblings('div.styledSelect');
                $styledSelect.attr('tabindex','0');
                // Show the first select option in the styled div
                var vall = $this.val();

                // Check to see if that select has default values selected
                //$this.find("option:first").remove();
                //var option = $("<option></option>");
                //$this.append(option);
                if(vall == '' || vall == 0) {
                    if ($this.data('defaults')) {
                        vall=$this.data('defaults');
                        var flagDefault = true;
                    }
                    //check for current user if you want to select by default in dropdown.
                    if($this.closest(".formRow.selectCurrentUser").length > 0){
                        vall = baseView.userId();
                    }
                }

                if (vall == '' || vall == 0 || isBlank(vall)) {
                    $styledSelect.text($this.children('option').eq(0).text());
                    $styledSelect.parent().find('a.closer').remove();
                    $styledSelect.text(moveInViewModel.translate("label_please_select"));
                } else {
                    var selected_text = $this.find('option[value="' + vall + '"]').text();
                    //default value should be selected.
                    if ($this.is("select")){
                        if($this.find('option[value="' + vall + '"]').length > 0 && vall) {
                            $this.find('option[value="' + vall + '"]').attr("selected",true);
                        } else {
                            if(vall) {
                                $this.find('option').each(function() {
                                    if($(this).text() == vall) {
                                        selected_text = vall;
                                        $(this).prop('selected',true);
                                        $selectRowControl =  $styledSelect.closest('.rowControl');
                                        $($selectRowControl).find('.error_message_dev').remove();
                                        $($selectRowControl).find('.orrange').removeClass("controlError");
                                        $($selectRowControl).find('.dd-select').removeClass("controlError");
                                    }
                                });
                            }
                        }
                    }
                    var selected_text_array = selected_text.split(" ");
                    $styledSelect.text(selected_text);
                    if (selected_text_array.length == 1
                            && selected_text.length > 15) {
                        $styledSelect.css("font-size", "13px");
                    }
                    //close button added with default values or current user select
                    $('<a class="closer"></a>').insertBefore($styledSelect);
                }
                // when any thing change in form then then formChange observable will be true;
                /*$styledSelect.parent().find('select').on('change', function(e) {
                    console.info('form change due to: ',$(e.target));
                    baseView.formChange(true);
                });*/

                //code for close button if default values or, edit page and current user select
                $styledSelect.parent().find('a.closer').on('click', function() {
                    $this.val('');
                    $(this).remove();
                    $styledSelect.parent().find('select').change();
                    baseView.formChange(true);
                    $styledSelect.text(moveInViewModel.translate("label_please_select"));
               });

                // Insert an unordered list after the styled div and also cache
                // the list
                var $list = $styledSelect.next('ul.options');
                // Insert a list item into the unordered list for each select
                // option
                $list.children('li').remove();
                

                var items = [];
                $this.find('option').each(function(index, value) {
                    items.push('<li rel="'+$(value).val()+'">'+$(value).text()+'</ul>');
                });
                $list.append(items.join(''));
                // Cache the list items
                var $listItems = $list.children('li');
                // Show the unordered list when the styled div is clicked (also
                // hides it
                // if the div is clicked again)
                $styledSelect.click(function(e) {
                	e.stopPropagation();
                    var visibilty = '';
                  //  console.info("dropdown click trigger count left this to determine unnecessary click binding");
                    if($(this).closest('.orrange').hasClass('disableSelect')){
                    } else {
                        $('div.styledSelect.active').each(
                                function() {
                                    $(this).removeClass('active')
                                    .next('ul.options').css('visibility',
                                    'hidden');
                        });
                      var visibilty = $(this).toggleClass('active').next('ul.options').css('visibility');
                    }
                    $(this).next('ul.options').css(
                            'visibility',
                            (visibilty =='hidden') ? 'visible' : 'hidden'
                        );

                });

                // Usman Shah Code
                // Fancy dropdown should behave like standard select dropdown
                var $ulVal = $($styledSelect).next('ul.options'); var $li = $ulVal.children('li'); var searchStr = '';
                $("html").keyup(function(e) {
                   if($($styledSelect).is(":focus")) {
                        var formRowControl = $($styledSelect).closest('.formRow');
                        var currentUl = $($styledSelect).toggleClass('active').next('ul.options');
                        var key = String.fromCharCode(e.keyCode); searchStr = searchStr + key;
                        setTimeout(function() { searchStr = ''; },500);
                        var regex = new RegExp('^' + (searchStr + '').replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi"); $li.removeClass('selected');
                        var $matchStr = $li.filter(function() { return regex.test($(this).text()); }).first().addClass('selected');
                        var list = $($styledSelect).toggleClass('active').next('ul.options');
                        if($matchStr.text()) {
                            var liCurrentOffSet = $(currentUl).find('li.selected').offset();
                            var liFirstOffSet = $(currentUl).find('li').first().offset();
                            if(typeof liCurrentOffSet === "undefined" || typeof liFirstOffSet === "undefined") {
                                // Undefined Objects
                            } else {
                                var newpos = liCurrentOffSet.top - liFirstOffSet.top;
                                $(currentUl).scrollTop(newpos);
                                if(!$(formRowControl).hasClass('dsearch')) {
                                    $($styledSelect).text($matchStr.text());
                                    $($styledSelect).closest('.select.orrange').find('a.closer').each(function() { $(this).remove(); });
                                    $('<a class="closer"></a>').insertBefore($styledSelect);
                                    $($styledSelect).closest('.select.orrange').find('select option').attr('selected', false);
                                    $($styledSelect).closest('.select.orrange').find('select option').eq(0).val($($matchStr).attr('rel')).text($($matchStr).text());
                                }
                                $($styledSelect).closest('.select.orrange').find('a.closer').click( function() {
                                    $(this).closest('.select.orrange').find('select').children('option').eq(0).text('');
                                    $(this).closest('.select.orrange').find('select').children('option').eq(0).val('');
                                    $styledSelect.text('');
                                    $(this).remove();
                                });
                            }
                        }
                    }
                });

                //End of Usman shah code


                // Hides the unordered list when a list item is clicked and
                // updates the
                // styled div to show the selected list item
                // Updates the select element to have the value of the
                // equivalent option
                $listItems.click(function(e) {
                    e.stopPropagation();
                    // Checking for duplication start
                    var selectName = $(this).parent().siblings('select').attr('name');
                    var allowMultiple = $(this).parent().siblings('select').attr('allowmultiple');
                    var similarSelectBox = $(this).parents('form').find('select[name="'+ selectName +'"]');
                    var selectedVal = $(this).attr('rel');
                    var duplication = false;
                    if (selectedVal != '' && similarSelectBox.length > 1) { // skip on empty value
                        $.each(similarSelectBox, function(index, value) {
                            if (!allowMultiple && selectedVal == $(this).val()) {
                                duplication = true;
                                moveInViewModel.popUpWindow.message(moveInViewModel.translate('label_duplicate'));
                            }
                        });
                    }
                    if (!allowMultiple && duplication)
                        return duplication;
                    // Checking for duplication end

                    var styled_text = $(this).text();
                    var styled_text_array = styled_text.split(" ");
                    $styledSelect.text(styled_text).removeClass('active');
                    if (styled_text_array.length == 1
                            && styled_text.length > 15) {
                        $styledSelect.css("font-size", "13px");
                    } else {
                        $styledSelect.css("font-size", "14px");
                    }
                    $this.val($(this).attr('rel')).change();
                    $list.css('visibility', 'hidden');
                    // $this.triggerHandler('click');
                    if ($this.attr('data-onclick')) {
                        eval($this.attr('data-onclick'));
                    }
                    if (styled_text != $this.children('option').eq(0).text()) {
                        $styledSelect.siblings("a.closer").remove();
                        $('<a class="closer"></a>').insertBefore($styledSelect);
                    } else {
                        //$styledSelect.siblings("a.closer").remove();
                    }
                    // alert($this.val()); //Uncomment this for demonstration!
                    /*
                     * $('a.closer').click(function() {
                     * $styledSelect.text($this.children('option').eq(0).text());
                     * $this.val(''); $(this).remove(); });
                     */
                    $styledSelect.siblings('a.closer').click(
                            function() {
//                                $styledSelect.text($this.children('option').eq(0).text());
                                $this.val('').change();
                                $(this).remove();
                                baseView.formChange(true);
                                $styledSelect.text(moveInViewModel.translate("label_please_select"));
                            });

                    saveDropdownValueHistory($this);
                    baseView.formChange(true);
                });
                // Hides the unordered list when clicking outside of it
                $(document).click(function(e) {
                    if ($(e.target).closest("ul.options").length > 0) {
                        return false;
                    }
                    $styledSelect.removeClass('active');
                    $list.css('visibility', 'hidden');
                });

                // Edit mode disable
                if ($styledSelect.parents('.editDisableDropDown').length) {
                    if ($styledSelect.parents('form').length && $styledSelect.parents('form').attr('action')) {
                        /*if ($styledSelect.parents('form').attr('action').search('/new') < 0) {
                            $styledSelect.off('click');
                        } else {
                            $styledSelect.parents('.editDisableDropDown').removeClass('editDisableDropDown');
                            console.info('ELSE');
                        }*/

                        if (!isBlank($styledSelect.text())) {
                            $styledSelect.off('click');
                        } else {
                            $styledSelect.parents('.editDisableDropDown').removeClass('editDisableDropDown');
                        }
                    }
                }
            });

}
(function($) {
    $(window).load(function() {
        $(".light ul.options").mCustomScrollbar({
            scrollInertia : 0
        });
        $(".dark ul.options").mCustomScrollbar({
            scrollInertia : 0,
            theme : "dark"
        });
        $(".dd-options").mCustomScrollbar({
            scrollInertia : 0,
            theme : "dark"
        });
    });
})(jQuery);

//Show hide Messages custom binding
ko.bindingHandlers.fadeVisible = {
        init : function(element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on
            // the value
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we
            // can handle values that may or
            // may not be observable
        },
        update : function(element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in
            // or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
        }
};

///date time picker on edit page work
function newDateTimePickerEdit(container) {
    if($(container).find('input[data-mask="date_time_picker_movein"]')) {
        $(container).find('input[data-mask="date_time_picker_movein"]').each(function(){
            var currControl = $(this);
            var curntContainer = $(currControl).parent();
            if($(curntContainer).find('.newDatePicker')) {
                var dateTimeStr = $(currControl).val();
                var dateTimeArr = dateTimeStr.split(' ');
                $(curntContainer).find('.newDatePicker').val(dateTimeArr[0]);
                $(curntContainer).find('.newTimePicker').attr('value',dateTimeArr[1]);
            }
        });
    }
}
/*
 * Autor: Usman Shah
 * House&street and Postcode&city functions. which is used in edit page to handle its values*/
function postcodeCityEdit(container) {
    if($(container).find('input[name="label_postcode_and_city"]')) {
        $(container).find('input[name="label_postcode_and_city"]').each(function(){
            var currControl = $(this);
            var curntContainer = $(currControl).parent();
            if($(curntContainer).find('.postcode')) {
                var postcodeCityStr = $(currControl).val();
                var postcodeCityArr = postcodeCityStr.split(', ');
                $(curntContainer).find('.postcode').val(postcodeCityArr[0]);
                $(curntContainer).find('.city').attr('value',postcodeCityArr[1]);
            }
        });
    }
}
function houseStreetEdit(container) {
    if($(container).find('input[name="label_house_number_and_street"]')) {
        $(container).find('input[name="label_house_number_and_street"]').each(function(){
            var currControl = $(this);
            var curntContainer = $(currControl).parent();
            if($(curntContainer).find('.house')) {
                var houseStreetStr = $(currControl).val();
                var houseStreetArr = houseStreetStr.split(', ');
                $(curntContainer).find('.house').val(houseStreetArr[0]);
                $(curntContainer).find('.street').attr('value',houseStreetArr[1]);
            }
        });
    }
}

/**
 * Added loading div for network call
 * @returns //Inorder to hide loader just call resolve() on return object of this function
 * @author:Mudassar Ali
 */
function showLoader(){
    var deferredObject = $.Deferred();
    $('<div style="position: fixed;top: 70%;left: 50%;z-index:1000;" id="ajaxLoader"><b>'+jQuery.i18n.prop("Loading, please wait...")+'</b></div>').appendTo($('body'));
    $.when(deferredObject)
    .then(function (){
        $('#ajaxLoader').remove();
    });
    return deferredObject;
}

/**
 * Redirects page. This is for redirecting system_admin menu page to block menu page
 * @author Mudassar Ali
 */
function gridPageGuardForRedirecting(page,route,callback) {
    moveInViewModel.permission.checkRightsGuard(page, route, callback, false);
    if (route.length == 1 && route[0] == 'system_admin') {
        moveInViewModel.setPageTitle(moveInViewModel.translate('label_system_admin'));
        pager.goTo('#system_admin_block');
    } else {
        if(route.length > 0) {
            switch(route.length) {
                case 1:
                    moveInViewModel.setPageTitle(moveInViewModel.translate('label_'+route[0]).toUpperCase());
                    break;
                case 2:
                    moveInViewModel.setPageTitle(moveInViewModel.translate(route[1]).toUpperCase());
                    break;
                default :
                    moveInViewModel.setPageTitle(moveInViewModel.translate('label_'+route[0]).toUpperCase());
                    break;
            }
        }
        callback();
    }
}

function _validateDateTimeFields(curControl){
    $(curControl).prev().find('.error_message_dev').remove();
    $(curControl).prev().removeClass("error-message");
    $(curControl).find('.newTimePicker').removeClass('controlError');
    var date = $(curControl).find('.newDatePicker').val();
    var time = $(curControl).find('.newTimePicker').val();

    $(curControl).find('.newDatePicker').removeClass('controlError');
    $(curControl).find('.newTimePicker').removeClass('controlError');

    if (date != "" && time != "") {
        $(curControl).prev().find('.error_message_dev');
        $(curControl).prev().removeClass("error-message");
        $(curControl).find('input[data-mask="date_time_picker_movein"]').val(date +' '+ time);
        return false;

    } else if (!isBlank(date) && isBlank(time)) {
        $(curControl).find('.newTimePicker').addClass('controlError');
        $(curControl).prev().addClass("error-message");
    }
    else if (!isBlank(time) && isBlank(date)) {
        $(curControl).find('.newDatePicker').addClass('controlError');
        $(curControl).prev().addClass("error-message");
    }
    else {
        $(curControl).find('input[data-mask="date_time_picker_movein"]').val("");
        return false;
    }

    if($(curControl).prev().find('.error_message_dev').length == 0 && (isBlank(date) || isBlank(time)) ){
    	$(curControl).prev().addClass("error-message");
        $(curControl).prev().append('<div class="error_message_dev">'+jQuery.i18n.prop('message_validation_date_and_time')+'</div>');
    }
    return true;
}
//Convert dot notation data to nested objects data
//Author Mudassar Ali

function convertDotNotationToNestedObject(data) {
    var dataObjects = {}, t, parts, part;
    for (var k in data) {
      t = dataObjects;
      parts = k.split('.');
      var key = parts.pop();
      while (parts.length) {
        part = parts.shift();
        t = t[part] = t[part] || {};
      }
      t[key] = data[k]
    }
    return dataObjects;
}


function createUniqueCKBox(controlElem, isPreferred){
    var countTotalPreferred = 0;
    $(controlElem).closest("div .setContainer").find(".uniqueCKbox").prop('checked', false);
    $(controlElem).closest("div .setContainer").find(".uniqueCKbox").each(function(){
        $(this).next("label").removeClass('checkbox-checked');
        $(this).next("label").addClass('checkbox-unchecked');
        countTotalPreferred++;
    });
    if (isPreferred) {
        controlElem = $(controlElem).closest("div .setContainer").find(".uniqueCKbox").first();
    }
    if(countTotalPreferred > 1) {
        baseView.formChange(true);
    }
    $(controlElem).prop('checked', true);
    $(controlElem).next("label").removeClass('checkbox-unchecked');
    $(controlElem).next("label").addClass('checkbox-checked');
}
/**
 * Slider built for the person profile summery page
 * @author: bilal
 * you can override any subfunction by passing it in options array
 * and also can supply defaults to change default settings.
*/
jQuery.fn.extend({
    blockslider: function (defaults, options) {
        var slug = {
            target: $(this),
            isBusy: false,
            blocks: [],
            _defaults: {
                blockSelector: '> *',
                transitionTime: 800,
                gap: 50,
                lazy: false,
                buildBlocks: true,
                blockWidth: null
            },
            init: function(){
                 //-------- injecting data param to identify slider injection.
                $('<div class="nextSlide">></div><div class="prevSlide"><</div>').insertAfter(slug.target);
                slug.syncWidth();
                slug.wrapperWidth = slug.target.width();
                if (slug._defaults.buildBlocks == true) { slug.buildBlocks(); }
                else {
                    slug.blocks = slug.target.find(slug._defaults.blockSelector).filter(function(indx, block){
                        return isBlank($(block).text().trim()) ? false : true;
                    });
                }

                // ------- setting slide position to 0
                slug.target.data('pos', 0);

                slug.adjustPositions();
                slug.bindEvents();
                slug.target.data('blockslider', slug);
                if (gotProp(slug, 'afterInit')) { slug.afterInit(); }
            },
            syncWidth: function(){
                var windowWidth = $(document).width();
                var LeftNavWidths = 230 + 240;
                windowWidth = windowWidth - LeftNavWidths;
                $(slug.target).attr('style', 'width: '+windowWidth+'px !important; flex-flow: inherit; display: flex;');
                $(slug.target).siblings('.nextSlide').css({'left': windowWidth + 162});
            },
            buildBlocks: function(){
                var blockItems = slug.target.find(slug._defaults.blockSelector).filter(function(indx, block){
                        return isBlank($(block).text().trim()) ? false : true;
                    });
                var wrapWidth = slug.wrapperWidth;
                //-------- calculating blocks
                var blocks = [];
                var addedIndexes = [];
                $(blockItems).each(function(indx, crntBlock){
                    if (addedIndexes.indexOf(indx) != -1) { return true; }
                    var crntIdex = indx;
                    var crntBlock = getBlock([crntBlock], crntIdex);

                    while (crntIdex <= crntBlock.index) {
                        addedIndexes.push(crntIdex);
                        crntIdex++;
                    }
                    blocks.push(crntBlock.block);
                });
                slug.blocks = blocks;


                function getBlock(prevItems, crntIndex) {
                    var addedIndex = crntIndex+1;
                    if (addedIndex < blockItems.length) {
                        prevItems.push(blockItems[addedIndex]);
                    }

                    var crntWidth = 0;
                    $(prevItems).each(function(indx, item){
                        crntWidth = crntWidth + $(item).width();
                    });

                    var addAnother = crntWidth < wrapWidth && (wrapWidth - crntWidth) >= 100 ? true : false;
                    var atEnd = addedIndex+1 < blockItems.length ? false : true;

                    if (addAnother == true && atEnd == false) {
                        return getBlock(prevItems, addedIndex);
                    } else {
                        if (prevItems.length > 1 && atEnd == false) { prevItems.pop(); }

                        // -------- cover case of single item, with width greater then wrapper
                        if (prevItems.length == 1 && $(prevItems[0]).width() > wrapWidth) {
                            $(prevItems[0]).css('width', wrapWidth-200);
                        }

                        return {'block': prevItems, 'index': (atEnd) ? addedIndex : addedIndex-1};
                    }
                }
            },
            adjustPositions: function(){
                // ------- adjusting Positions
                slug.positions = [0];
                var startingPos = 0;

                $(slug.blocks).each(function(indx, crntBlock){
                    var crntBlockWidth = 0;

                    if (!isBlank(slug._defaults.blockWidth)) {
                        crntBlockWidth = slug._defaults.blockWidth;
                    } else {
                        $(crntBlock).each(function(indx, subBlock){
                            crntBlockWidth = crntBlockWidth + ((crntBlockWidth != 0) ? slug._defaults.gap : 0) + $(subBlock).width();
                        });
                    }

                    if (crntBlockWidth > slug.wrapperWidth) { crntBlockWidth = slug.wrapperWidth - 200; }

                    var slidePad = slug._defaults.gap;

                    if (!isBlank(slug._defaults.blockWidth)) {
                        slidePad = (slug.wrapperWidth - slug._defaults.blockWidth) / 3;
                    } else {
                        slidePad = (slug.wrapperWidth - crntBlockWidth) / 2;
                    }



                    if (crntBlock.length == 1 || isBlank(crntBlock.length)) {

                        $(crntBlock).css({
                            position: 'relative',
                            left: startingPos + slidePad,
                        });

                    } else {
                        var subPointer = startingPos + slidePad;
                        $(crntBlock).each(function(posIndx, subBlock){
                            $(subBlock).css({
                                position: 'relative',
                                left: subPointer,
                            });
                            subPointer = subPointer + slug._defaults.gap/2;
                        });
                    }

                    // ------- extending width pointer to include Next Items
                    if (!isBlank(slug._defaults.blockWidth)) {
                        startingPos = startingPos + slidePad;
                    } else {
                        startingPos = startingPos + slug._defaults.gap + slidePad;
                    }

                    // -------- skipping last position
                    if (indx+1 != slug.blocks.length) {
                        if (!isBlank(slug._defaults.blockWidth)) {
                            slug.positions.push(startingPos - slug._defaults.gap);
                        } else {
                            slug.positions.push(slidePad/2);
                        }
                    }

                    // ------- fixing issue with single block slide with very small width
                    if (crntBlock.length == 1 && crntBlockWidth < slug.wrapperWidth/2) { startingPos = startingPos + slidePad; }
                });
            },
            bindEvents: function(){
                slug.target.siblings('.top_check_boxes').find('.check_text').on('click', function(){

                    // ----- getting item index
                    var targetIndex = $(this).parent().prevAll('.single_check').length;
                    var targetPos = (!isBlank(slug._defaults.blockWidth) ? slug._defaults.blockWidth : slug.wrapperWidth)*targetIndex + slug.positions[targetIndex];
                    slug.target.animate({scrollLeft: targetPos}, slug._defaults.transitionTime, function(){
                        slug.target.data('pos', targetIndex);
                        slug.isBusy = false;
                    });
                });

                slug.target.siblings('.nextSlide, .prevSlide').on('click', function(){
                    if (slug.isBusy) { return false; }

                    var targetIndex = slug.target.data('pos');

                    var isNext = $(this).hasClass('nextSlide') ? true : false;
                    targetIndex = (isNext) ? ++targetIndex : --targetIndex;

                    if (targetIndex != -1 && targetIndex < slug.positions.length) {
                        var targetPos = (!isBlank(slug._defaults.blockWidth) ? slug._defaults.blockWidth : slug.wrapperWidth)*targetIndex + slug.positions[targetIndex];
                        slug.isBusy = true;
                        slug.target.animate({scrollLeft: targetPos}, slug._defaults.transitionTime, function(){
                            slug.target.data('pos', targetIndex);
                            slug.isBusy = false;
                        });
                    }
                });

                // ------- dragSlideEvent
                var mouseDown = false;
                var oldDragPos = 0;

                $(slug.target).on('mousedown', function(e){
                    mouseDown = true;
                })
                .on('mouseup', function(e){
                    mouseDown = false;
                    oldDragPos = 0;
                })
                .on('mousemove', function(e){
                    if (oldDragPos == 0) { oldDragPos = e.pageX; return false; }
                    if (mouseDown) {
                        var crntScrollLeft = slug.target.scrollLeft();
                        var isForward = oldDragPos < e.pageX ? true : false;
                        var newScrollLeft = (isForward) ? (crntScrollLeft - 8) : (crntScrollLeft + 8);
                        slug.target.scrollLeft(newScrollLeft);
                        oldDragPos = e.pageX;
                    }
                })
                .on('DOMMouseScroll', function(e){
                    if(e.originalEvent.detail > 0) {
                        $(slug.target).find('.nextSlide').click();
                    }else {
                        $(slug.target).find('.prevSlide').click();
                    }
                });
            },
            unbind: function(){
                slug.target.removeAttr('style');
                slug.target.siblings('.nextSlide, .prevSlide').off('click').remove();
                var oldSlugRef = slug.target.data('blockslider');

                if (!isBlank(oldSlugRef)) { $(oldSlugRef.blocks).removeAttr('style'); }
                slug.target.off('click');
                slug.target.removeData('blockslider');
            },
            rebind: function(){
                var oldSlugRef = slug.target.data('blockslider');
                $.extend(slug._defaults, oldSlugRef._defaults);

                slug.unbind();
                setTimeout(function(){
                    slug.init();
                }, 1000);

            }
        };

        // ------------ handle for calling special function
        var preventDefault = false;
        if (!isBlank(defaults) && typeof defaults == 'string') {
            preventDefault = true;
            switch(defaults) {
                case 'unbind':
                    slug.unbind();
                break;
                case 'rebind':
                    slug.rebind();
                break;
            }
        }

        if (preventDefault == false && !isBlank(options)) { $.extend(slug, options); }
        if (preventDefault == false && !isBlank(defaults) && typeof defaults != 'string') { $.extend(slug._defaults, defaults); }

        if (preventDefault == false && isBlank($(slug.target).data('blockslider'))) {
            if (slug._defaults.lazy == true) {
                $(slug.target).one('mouseenter', function(){
                    slug.init();
                });
            } else {
                slug.init();
            }
        }
    }
});
//
//$('#element').donetyping(callback[, timeout=1000])
//Fires callback when a user has finished typing. This is determined by the time elapsed
//since the last keystroke and timeout parameter or the blur event--whichever comes first.
//@callback: function to be called when even triggers
//@timeout:  (default=1000) timeout, in ms, to to wait before triggering event if not
//           caused by blur.
//Requires jQuery 1.7+
//
;(function($){
 $.fn.extend({
     donetyping: function(callback,timeout){
         timeout = timeout || 1e3; // 1 second default timeout
         var timeoutReference,
             doneTyping = function(el){
                 if (!timeoutReference) return;
                 timeoutReference = null;
                 callback.call(el);
             };
         return this.each(function(i,el){
             var $el = $(el);
             // Chrome Fix (Use keyup over keypress to detect backspace)
             // thank you @palerdot
             $el.is(':input') && $el.on('keyup keypress',function(e){
                 // This catches the backspace button in chrome, but also prevents
                 // the event from triggering too premptively. Without this line,
                 // using tab/shift+tab will make the focused element fire the callback.
                 if (e.type=='keyup' && e.keyCode!=8) return;

                 // Check if timeout has been set. If it has, "reset" the clock and
                 // start over again.
                 if (timeoutReference) clearTimeout(timeoutReference);
                 timeoutReference = setTimeout(function(){
                     // if we made it here, our timeout has elapsed. Fire the
                     // callback
                     doneTyping(el);
                 }, timeout);
             }).on('blur',function(){
                 // If we can, fire the event since we're leaving the field
                 doneTyping(el);
             });
         });
     }
 });

})(jQuery);

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

/**
 * Gets page title for edit or new mode for entity
 * @param $data
 */
function getPageTileForEntity(data, setDocumentTitle) {
    if ( data.name == undefined)
        return;
   //var temp = jQuery.i18n.prop(data.name);
    var temp = createFormTitle(data);
    var name = '';
    var res = '';
    if (data.formData && data.formData.formData.data.name) {
        name = data.formData.formData.data.name;
    }
    if (data.name =="label_users" && data.formData && data.formData.formData.data.firstName) {
        name = data.formData.formData.data.firstName;
    }
    if (data.name =="entity_form_answers" && data.formData && data.formData.formData.data.formName) {
        name = data.formData.formData.data.formName;
    }
    if (data.formData && data.formData.formData.data.key) {
        name = data.formData.formData.data.key;
    }
    if (data.type == 'edit' && data.id !='new' && data.id !='duplicate')
        res = temp + ' : ' + name;
    else
        res = temp;
    if (setDocumentTitle) {
        document.title = [res];
    }
    return res;
}
/**
 * create and return form tilte for edit and new form.
 * $param data
 */
function createFormTitle(data) {
    var title = '';
    if(data.id == 'duplicate') {
        title = jQuery.i18n.prop('label_new' + data.name.replace('label_','_').replace('entity_','_'));
    }
    else {
        title = jQuery.i18n.prop(((data.id=='new')?  'label_new' : 'label' )+(data.name.replace('label_','_').replace('entity_','_')));
    }
    return title;
    //return jQuery.i18n.prop(((data.id=='new')?  'label_new' : 'label' )+(data.name.replace('label_','_').replace('entity_','_')));

}

function getIndexOfObject(list, item) {
    var len = list.length;
    for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        for (var j = 0; j < keys.length; j++) {
            var value = list[i][keys[j]];
            if(value instanceof Array) {
                for(var index in value) {
                    if(item[keys[j]][index] !== value[index]) {
                        flg = false;
                    }
                }
            } else {
                if (item[keys[j]] !== value) {
                    flg = false;
                }
            }
        }
        if (flg == true) {
            return i;
        }
    }
    return -1;
}

